import LoadingPage from "@/components/features/core/error/components/LoadingPage";

export default LoadingPage;
